import { gql } from "@apollo/client";

export const lensSpace = gql`
    fragment LensSpaceAll on LensSpace {
        id
        name
        organizationId
    }
`;

export const resourceContainer = gql`
    fragment ResourceContainerAll on ResourceContainer {
        id
        name
        roles
        kind
        parentName
    }
`;

export const childResources = gql`
    fragment ChildResourcesAll on ChildResources {
        resourceList {
            ...ResourceContainerAll
        }
    }
    ${resourceContainer}
`;

export const organization = {
    all: gql`
        fragment OrganizationAll on MyLensesOrganization {
            id
            name
            cameraKitEnabled
            lensSpacesList {
                ...LensSpaceAll
            }
        }
        ${lensSpace}
    `,
    name: gql`
        fragment OrganizationName on MyLensesOrganization {
            name
        }
    `,
};
